/**
 * @name iFastConstants
 * @desc Common constants file used in iFastWeb Plus
 */
angular.module("iFAST.common")
    .factory("iFastConstants", function() {
        "use strict";
        var constantsObject = {
            //IFASTWEB_CONTEXT_ROOT: "/ifastweb",
            SERVER_DATEFORMAT : "YYYY-MM-DD",
            SERVER_KENDODATEFORMAT : "yyyy-MM-dd",
            SERVER_DATETIMEFORMAT : "yyyy-MM-dd HH:mm:ss",
            TIMESTAMP_FORMAT : "MMMM DD, YYYY hh:mm tt",
            ATL_TIMESTAMP_FORMAT : "DD MMMM YYYY hh:mm tt",
            IFASTWEB_CONTEXT_ROOT: "/ifastweb20_rest_war_exploded",
            PRINTCSV_DELIMITER : " * ",
            TRUE: "TRUE",
            VISIBLE: "Visible",
            VISIBLE_MORE: "Visible_More",
            CSV_VISIBLE: "CSV_Visible",
            PDF_VISIBLE: "PDF_Visible",
            GAINLOSS : "GainLoss",
            FILTER_ASOFDATE: "date",
            FILTER_FROMDATE: "frDate",
            FILTER_TODATE: "toDate",
            PLACEHOLDER: "placeholder",
            CONTEXT_FUND : "FundContext",
            FUNDSEARCH : "FundSRCH",
            ACCTSEARCH: "AcctSRCH",
            ADVRSEARCH: "AdvrSRCH",
            CHARWAIT : "CharWait",
            TIMEWAIT : "TimeWait",
            AUTO : "AUTO",
            SEARCHFIELD : "searchField",
            ACCOUNT_LVL_SUMMARY: "accountLevelSummary",
            ACCTDETAILSADDRTAB: "ACCTDETAILSADDRTAB",
            ACCTDETAILSCONTTAB: "ACCTDETAILSCONTTAB",
            ACCTDETAILSOVERTAB: "ACCTDETAILSOVERTAB",
            ADVISORPROFILEID : "AdvisorProfile",
            ADHOCSTMTSMODALTRANSCOMPACT: "ADHOCSTMTSMODALTRANSCOMPACT",
            ADHOCSTMTSMODALTRANS: "ADHOCSTMTSMODALTRANS",
            APPLY:"apply",
            OTHERPROFILE: "AdvisorProfileOthers",
            DETAILPROFILE: "AdvisorProfileDetail",
            BROKERNAME :"brokerName",
            BROKERCODE:"brokerCode",
            BRANCHNAME:"branchName",
            REP_ADDR_TYPE:"REP",
            MORE : "more",
            TAXFORM : "TF",
            CONTRIB : "CR",
            STATEMENT : "S",
            LESS: "less",
            EMAIL: "email",
            COMPACT: "COMPACT",
            EXPANDED: "EXPANDED",
            VALID: "VALID",
            AGGREGATES: "aggregates",
            EMPTYVALUE: "emptyValue",
            TRADESTATUSICON : "tradeStatusIcon",
            DISPLAY_ORDER: "Display_Order",
            CSV_DISPLAY_ORDER: "CSV_Display_Order",
            ROW_DISPLAY: "RowDisp",
            FUNDPRICEVALID: "FUNDPRICEVALID",
            API_CALL_ERROR_MESSAGE: "apiCallErrorMessage",
            ERROR_CODE_SEPERATOR: "errorCodeSeparator",
			ERROR_CODE_TERMS_AND_COND_DECLINED: "termsAndConditionsDeclined",
            ERROR_CODE_SYSTEM_TIMEOUT: "timeoutErrorMsg",
            SCETRUSTASHTML: "sceTrustAsHtml",
            FUNDSERVECODE : "fundServCode",
            COLUMNHEADERFORMAT: "columnHeaderFormat",
            FIELDS: "fields",
            COLUMN: "column",
            LABEL: "Label",
            GROUPBYFIELDNAME: "groupBy",
            VALUE: "Value",
            HIDDEN: "hidden",
            LABEL_ALT: "Label_Alt",
            DESCRIPTION: "Description",
            SORTABLE: "Sortable",
            SORTDESC: "desc",
            SORTASC: "asc",
            SORTDEFAULTCOLUMN: "SortDefaultColumn",
            SORTDEFAULTORDER: "SortDefaultOrder",
            SETSORTDEFAULTCOLUMN: "SetSortDefaultColumn",
            DATATYPE_NUMBER: "number",
            COMMSUMMARY : "COMMSUMMARY",
            COMMISSIONS : "COMMISSIONS",
            TRAILERFEES : "TRAILERFEES",
            MANAGERFEES : "MANAGERFEES",
            TOLABEL : "toLabel",
            FROMLABEL : "fromLabel",
            //DATATYPE_DATE: "date",
            DATATYPE_STRING: "String",
            TEXT_ALIGN_RIGHT: "text-right",
            TEXT_ALIGN_LEFT: "text-left",
            TEXT_ALIGN_CENTRE: "text-center",
            ANGLE_BRACKET_CLOSE: ">",
            TRANSLATION_CODE: "Translation_Code",
            EMPTY_VALUE: "EmptyValue",
            FORMAT_CODE: "Format_Code",
            FIELD_NOT_EXISTS_VALUE: "fieldNotExistsValue",
            HEADER_FORMAT_CODE: "Header_Format_Code",
            DISPLAYFORMAT: "displayFormat",
            DECIMAL_NUMBER_FORMAT:"0,0.000",
            ZERO_VALUE: "ZeroValue",
            NO_WRAP: "NoWrap",
            DATATYPE_DECIMAL: "Decimal",
            DATATYPE_DATE: "Date",
            DATATYPE_INTEGER: "Integer",
            DATA_TYPE: "Data_Type",
            IFDS_NEGATIVE_VALUE: "ifds-negative-value",
            IFDS_INFO_ICON_FIELD: "ifast-info-icon-field",
            FILTER_INFO_ICON: "INFO",
            FILTER_INFO_UE_ICON: "INFO_UE",
            FILTER_INFO_PENDING_ICON: "INFO_PEND",
            FILTER_DIST_INSTR_INFO: "DIST_INSTR_INFO",
            FILTER_REG_TRANSFER_ACTUAL_ALLOC_INFO: "REG_TRANSFER_ACTUAL_ALLOC_INFO",
            FILTER_REG_TRANSFER_EXPECTED_ALLOC_INFO: "REG_TRANSFER_EXPECTED_ALLOC_INFO",
            FILTER_INFO_ICON_CLASS: "fa-info-circle fa-1",
            FILTER_HEADER_INFO_ICON: "INFOHEADER",
            FILTER_MAG_ICON: "MAG",
            FILTER_MAG_ICON_CLASS: "fa-search-plus",
            FILTER_MORTAR_ICON: "MORTAR",
            FILTER_MORTAR_ICON_CLASS: "fa-graduation-cap",
            FILTER_LIST_ICON: "LIST",
            FILTER_LIST_ICON_CLASS: "fa-th-list",
            FILTER_GROSS_NET_ICON: "GRSNET",
            FILTER_TRANS_STATUS_ICON: "TRNSTS",
            FILTER_TRADE_STATUS_ICON: "TRDSTS",
            FILTER_TRADE_STATUS_ICON_CLASS: "fa-minus-circle",
            FILTER_LOCK_ACCOUNT_ICON: "LOCK",
            FILTER_LOCK_ACCOUNT_ICON_CLASS: "fa-lock",
            TERMINATED_ACCOUNT_CODE: "30",
            IGNORE_HEADER_UNITS : "units",
            IGNORE_HEADER_WIREORDNUM : "wireOrdNum",
            FIELD: "field",
            FIELDIDS:"fieldIDs",
            HELPICON: "helpIcon",
            DONWLOADCSVICON: "downloadIcon",
            PDFICON: "pdfIcon",
            PRINTERICON: "printerIcon",
            COLLAPSEOPENICONS: "collapseOpenIcons",
            COMPACTEXPANDICONS: "compactExpandIcons",
            ICON_FORMAT_CODE: "iconFormatCode",
            ICON_FIELD: "iconField",
            MATURITY_UNITS: "maturityUnits",
            MATURITY_DETAILS: "maturityDetails",
            FORMAT_CODE_LCF: "LCF",
            FORMAT_CODE_FSL: "FSL",
            FORMAT_CODE_FSC: "FSC",
            FORMAT_CODE_FSC_PEND: "FSC_PEND",
            FORMAT_CODE_DR: "DR",
            FIELD_LNAME: "lname",
            FIELD_FNAME: "fname",
            FIELD_ACCT: "acct",
            FIELD_SLSREPCODE: "slsRepCode",
            FIELD_ALTACCT: "altAcct",
            FIELD_OTHREF: "otherRef",
            FIELD_TAXTYPE: "taxType",
            FIELD_FUND_SERVE_CODE: "fundServCode",
            PAGE_ORIENTATION: "pageOrientation",
            PDF_FILTER_CRITERIA_TITLE: "Filter Criteria",
            PDF_STYLE_HEADER: "header",
            PDF_STYLE_TABLE_HEADER: "tableHeader",
            PDF_STYLE_TABLE_HIDDEN_VALUE: "hiddenValue",
            PDF_STYLE_TEXT: "text",
            PDF_STYLE_TEXT_BOLD: "textBold",
            PDF_STYLE_TITLE: "title",
            PDF_STYLE_FILTER_LABEL: "filterLabel",
            PDF_STYLE_FILTER_VALUE: "filterValue",
            PDF_STYLE_ADDR_VALUE: "addrValue",
            PDF_STYLE_ERROR_VALUE: "errorValue",
            PDF_STYLE_LABEL: "label",
            PDF_STYLE_VALUE: "value",
            PDF_PRINT_DEFAULT_VALUE: "N/A",
            PDF_COLUMN_WIDTH: "pdfWidths",
            PDF_COLUMN_NUM: "13",
            PDF_LOGO_WIDTH:"PdfLogoWidth",
            PDF_STYLE_GROUP_TEXT:"groupText",
            PAGESIZE_COMPACT : "pageSizeCompact",
            PAGESIZE_EXPANDED : "pageSizeExpanded",
            FILTERS: "filters",
            HTML_ENCODE_SPACE: "&nbsp;",
            DEFAULT_REPORT_DATE_FORMAT: "YYYY-MM-DD",
            DEFAULT_DATE_FORMAT: "DD/MM/YYYY",
            MONTH_FIRST_DATE_FORMAT: "MM/DD/YYYY",
            FULL_DATE_FORMAT_EN: "MMMM DD, YYYY",
            FULL_DATE_FORMAT_FR: "DD MMMM YYYY",
            CSV_TIME_FORMAT: "hh:mm:ss tt",
            MOMENT_DATE_STRICT_FORMAT: "D/M/YYYY",
            DATE_VALIDATION_REGEXP:"^[0-9/]*$", // ^(|[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4})$
            MARKET_VALUE_VALIDATION_REGEXP:"^[0-9,.]*$", //excludes negative numbers.
            CLIENT_CODE: "clientCd",
            SINCE_INCEPTION: "sncInc",
            DATE_RANGE: "dtRnge",
            DISCLAIMER: "disclaimer",
            PRINT_DISCLAIMER: "printDisclaimer",
            COLLAPSE: "Collapse",
            PDF_ICON_ALT_TEXT: "pdfIconAlt",
            CSV_ICON_ALT_TEXT: "csvIconAlt",
            HELP_ICON_ALT_TEXT: "helpIconAlt",
            BACK_BUTTON: "backButton",
            COLLAPSE_ICON_ALT_TEXT: "collapseIconAlt",
            EXPAND_ICON_ALT_TEXT: "expandIconAlt",
            MAXIMIZE_ICON_ALT_TEXT: "maximizeIconAlt",
            MINIMIZE_ICON_ALT_TEXT: "minimizeIconAlt",
            CLOSE_ICON_ALT_TEXT: "closeIconAlt",
            MSG_INFO : "INFO",
            MSG_WARN : "WARN",
            MSG_ERROR : "ERROR",
            GLOBAL_CONFIG: "IFASTWEB",
            ALLFUNDS_PLACEHOLDER : "allFundPlaceholder",
            ACCOUNT_PLACEHOLDER : "accountPlaceholder",
            ADVISOR_PLACEHOLDER : "advisorPlaceholder",
            SALESREP_PLACEHOLDER : "salesRepPlaceholder",
            ALLACCOUNT_PLACEHOLDER : "allAccountPlaceholder",
            TRANSLATION: "translation",
            FUNDCODE: "fundCode",
            CURRCODE: "currCode",
            FUND: "fund",
            EQUALS: "equals",
            FREEUNITAMOUNT: "FreeUnitsAmount",
            FREEUNITUNIT: "FreeUnitsUnit",
            AMS_CURRENT_ALLOCATION:"AMSCurrentAllocation",
            AMS_CURR_ALLOC:"AMSCurrAlloc",
            ADHOCHOLDINGS: "AdHocStmtsModalHoldings",
            ADHOCTRANSACTIONS: "AdHocStmtsModalTrans",
            MATUNITS: "MatUnits",
            MATUNITSUNITS: "MatUnitsUnits",
            MATUNITSDETAILS: "MatUnitsDetails",
            INVDETAILDTOLIST: "invDetailDTOList",
			INVSUMMLISTDTO: "invSummListDTO",
            ORIGUNITSTOTAL : "origUnitsTotal",
            PENDING: "PENDING",
            TRANSACTIONS: "TRANSACTIONS",
            RESP: "RESP",
            RDSP: "RDSP",
            RESPBENEF: "RespSummaryModalBenef",
            PASTEVENTS: "PASTEVENTS",
            UPCOMINGEVENTS: "UPCOMINGEVENTS",
            FILTER_YESTD : "YESTD",
            FILTER_YTD: "YTD",
            FILTER_LAST_YEAR: "lstYr",
            LINK_NAME_TRADEDETAILVIEW: "tradeDetailView",
            LINK_NAME_ACCOUNTCONTEXT: "AcctContext",
            LINK_NAME_ADVISORCONTEXT: "AdvrContext",
            DEFAULT_MONEY_VALUE: "AF,AW,PW,TO",
            PRIMARY: "Primary",
            OWNER: "owner",
            ACCTTYPE: "acctType",
            JOINTTYPE: "2",
            SIGNATURE: "signature",
            NOTAPPLICABLE: "NotApplicable",
            UNDEFINED: "undefined",
            FIELD_FUND_COMPANY: "fundCompany",
            FIELD_EXT_FUND_CODE: "extFundCode",
            FIELD_FUND_DESC: "fundDesc",
            FIELD_CLASS_CODE: "classCode",
            THOUSAND_SEPARATOR: "thousandSeparator",
            DECIMAL_SEPARATOR: "decimalSeparator",
            TERMS_AND_CONDITIONS_LABEL: "termsAndConditions",
            CONTACT_US_LABEL: "contactUs",
            COPYRIGHT_LABEL: "copyright",
            FOOTER_SEPARATOR: "footerSeparator",            
            SALES_REP_LIST: "SALES_REP_DROP_DOWN_LIST",
            CURRENCY_SYMBOL: "currencySymbol",
            ABBR_BILLION: "abbrBillion",
            ABBR_MILLION: "abbrMillion",
            ABBR_THOUSAND: "abbrThousand",
            ABBR_TRILLION: "abbrTrillion",
            CSV_DATE_LABEL : "dateLabel",
            CSV_TIME_LABEL : "timeLabel",
            LOGO_LINK:"logoLink",
            LOGO_TITLE:"logoTitle",
            COMPANY_NAME:"companyName",
            BUSPHONE:"busPhn",
            BUSPHONEEXT:"busExt",
            ACCESS_TYPE_ADV: "ADV",
            ACCESS_TYPE_BRN: "BRN",
            ACCESS_TYPE_ACCADM: "ACCADM",
            ACCESS_TYPE_BKOFFW: "BKOFFW",
            ACCESS_TYPE_BKOFFA: "BKOFFA",
            ACCESS_TYPE_BRK: "BRK",
            ACCESS_TYPE_INV: "INV",
            COL_POSTFIX:"PostFix",
            COL_POSTFIX_SPACE: "PostFixSpace",
            COL_POSTFIX_EMPTY: "PostFixEmpty",
            FILTER_DEFAULT_CURR:"CDN",
            FRST60: "FRST60",
            MONEY_IN_VALUE: "ED,ID,TI",
            LAST_PAY: "lstPay",
            LAST_PAID: "lstPaid",
            SEARCH_FOR: "searchFor",
            NO_DATA_FOUND: "noDataFound",
            GO_TO_FIRST_PAGE: "goToFirstPage",
            GO_TO_PREV_PAGE: "goToPrevPage",
            GO_TO_NEXT_PAGE: "goToNextPage",
            GO_TO_LAST_PAGE: "goToLastPage",
            ITEMS_PER_PAGE: "itemsPerPage",
            PAGER_OF: "pagerOf",
            EMPTY_GRID: "emptyGrid",
            CSV_DEFAULT_VALUE: "N/A",
            LANG_EN: "en",
            LANG_FR: "fr",
            CULTURE_EN: "en-CA",
            CULTURE_FR: "en-FR",
            STAR_SEPARATOR: "*",
            AS_OF_LABEL: "asOfLabel",
            PERIOD_LABEL: "periodLabel",
            FROM_LABEL: "fromLabel",
            TO_LABEL: "toLabel",
            FOR_LABEL: "forLabel",
            OUTPUT_LABEL: "outputLabel",
            XLS_LABEL: "xlsLabel",
            PDF_LABEL: "pdfLabel",
            PRIVACY_LABEL: "privacy",
            PAGE_LABEL: "page",
            OF_LABEL: "of",
            ON_LABEL: "on",
            ATL_ON_LABEL: "le",
            GENERATEBY_LABEL: "generateBy",
            GENERATE_REPORT_ON_TIMESTAMP: "generateReportOnTimestamp",
            GENERATE_REPORT_ON_LABEL: "generateReportOnLabel",
            TOTAL_LABEL: "total",
            STATEMENT_LABEL: "statement",
            ACCOUNT_NUM_LABEL: "acctNum",
            GENERATE_REPORT_LABEL: "generateReportLabel",
            CANCEL_LABEL: "cancelLabel",
            
            MONEY_OUT: "moneyOut",
            ALL_TRANSACTIONS: "allTransactions",
            TXN_TYPE_TR: "TR",
            TXN_TYPE_PW: "PW",
            TXN_TYPE_CODE: "txnTypeCode",
            ADVISOR_LANDING_PAGE: "advisor",
            ACCOUNT_LANDING_PAGE: "account",
            FUND_LANDING_PAGE: "fund",
            FUND_FACT_URL: "fundFactURL",
            TOTAL_FIELD: "TotalField",
            PLUS_SIGN_PLACEHOLDER: String.fromCharCode(230),
            RECAPTCHAPPUBLICKEY: "6LdSzf4SAAAAAP8IbU-e3uu3HvkZHsY9X7-mmT5J",
            IE_CONTRIBUTION_RECEIPTS_DL_TYPE: "CONTRIBUTION_RECEIPTS",
            IE_TAX_FORMS_DL_TYPE: "TAX_FORMS",
            IE_DST_DL_TYPE: "DST",
            IE_BOB_DL_TYPE: "BOB",
            SECTION: "Section",
            FIELD_MGMT_CODE: "mgmtCode",
            DROPDOWN_TITLE: "dropdownTitle",
            ANNUITANT: "annuitant",
            JOINT_LIFE: "jointLife",
            FIELD_BAYCOMM: "bayComm",
            SPACE_GAP_HEIGHT: 5,
            SYSTEMATICPLANSOBJ: "SystematicPlans",
            PDF_FOOTER_HEIGHT: "pdfFooterHeight",
            PDF_FILTER_TITLE: "pdfFilterTitle",
            PDF_FOOTER_HEIGHT_SIZE: 80,
            PDF_TRANSSUM_FONTSIZE:'fontSize',
            LINK_TARGET: "linkTarget",
            WEB_FOCUS_AVAILABLE: "available",
            SSO_LOGIN_ERROR_REDIRECT_URL: "ssoLoginErrorRedirectUrl",
            SSO_LOGIN_ERROR_MSG_CODE: "ssoLoginErrorMsg",
            API_USER_ID_ERROR_MSG_CODE: "apiUserIdErrorMessage",
            PERIOD_TYPE_YESTD : "YESTD",
            PERIOD_TYPE_PSTWK: "PSTWK",
            PERIOD_TYPE_LSTWK: "LSTWK",
            PERIOD_TYPE_LST2WK : "LST2WK",
            PERIOD_TYPE_PSTMN : "PSTMN",
            PERIOD_TYPE_LSTMTH : "LSTMTH",
            PERIOD_TYPE_PSTQTR : "PSTQTR",
            PERIOD_TYPE_LSTQTR : "LSTQTR",
            PERIOD_TYPE_SNCINC : "SNCINC",
            PERIOD_TYPE_YTD : "YTD",
            PERIOD_TYPE_FRST60 : "FRST60",
            PERIOD_TYPE_LSTYR : "LSTYR",
            PERIOD_TYPE_SINCE_INCEPTION : "SNCINCPTN",
            AUTO_COMPLETE_SEARCHBUTTONTOOLTIP : "searchButtonToolTip",
            AUTO_COMPLETE_MATCH_NAME : "NAME",
            AUTO_COMPLETE_MATCH_ACCT : "ACCT",
            AUTO_COMPLETE_MATCH_ALTACCT : "ALTACCT",
            AUTO_COMPLETE_MATCH_OTHREF : "OTHREF",
            AUTO_COMPLETE_MATCH_CODE : "CODE",
            AUTO_COMPLETE_RESULTS_ADVISOR : "AUTO_ADVISOR_SEARCH_SAVED",
            AUTO_COMPLETE_RESULTS_ACCOUNT : "AUTO_ACCOUNT_SEARCH_SAVED",
            AUTO_COMPLETE_RESULTS_FILTER_ACCOUNT : "FILTER_ACCOUNT_SEARCH",
            AUTO_COMPLETE_RESULTS_FILTER_ADVISOR : "FILTER_ADVISOR_SEARCH",
            WEB_ANALYTICS_RESULT : "Result",
            WEB_ANALYTICS_SEARCHFOR : "searchFor",
            WEB_ANALYTICS_LOAD : "Load",
            FONT_AWESOME_SEARCH : "fa-search",
            FONT_AWESOME_TIMES : "fa-times",
            LOCATION_ACCOUNT : "/account",
            LOCATION_ADVISOR : "/advisor",
            LOCATION_FUND : "/fund",
            UNSETTLE_TRANSACTION_ICON: "U",
            REPORTS_LINK_TO_IFASTWEB: "linkToIfastWeb",
            DELETE_MSG_POPUP : "DELETEMSGPOPUP",
            CANCEL_MSG_POPUP : "CANCELMSGPOPUP",
            CANCEL_BTN : "CANCELBTN",
            PARENT_ERROR: "parentError",
            PDF_HEADER_TITLE: "title",
            PDF_TOTAL: "total",
            PDF_ADDRESS: "address",
            PDF_URL: "url",
            PDF_PHONE: "phone",
            PDF_PHONE_URL_DESC: "phoneUrlDescr",
            PDF_SHOWADDRESSONLASTPAGE: "showAddressOnLastPage", /* Invesvo address show on last page of ad-hoc*/
            PDF_PAGE_NUM_INFO: "pageNumInfo",
            HTML_FORMAT_CODE_CHECKBOX: "CHECKBOX",
            HTML_FORMAT_CODE_INPUT_TEXT: "INPUT_TEXT",
            HTML_FORMAT_CODE_DROPDOWN: "DROPDOWN",
            HTML_FORMAT_CODE_ICON: "ICON",
            HTML_FORMAT_CODE: "HTML_Format_Code",
            CURR:"curr",
            CURR_USD: "USD",
            CURR_USA: "USA",
            /*Block of Business*/
            BOB :{
                /*Object Id*/
                ADJUSTED_COST_BASE_OBJECT_ID: "AdjustedCostBase",
                ASSET_UNDER_MGT_OBJECT_ID: "AssetUnderMgt",
                CAPITAL_GAIN_OBJECT_ID: "CapitalGain",
                DSC_FREE_UNIT_OBJECT_ID: "DscFreeUnit",
                TRAILER_FEE_OBJECT_ID: "TrailerFee",
                TRANSACTION_HISTORY_OBJECT_ID: "TransactionHistory",
                MANAGEMENT_FEES_OBJECT_ID: "ManagementFees",
                SALES_COMMISSIONS_OBJECT_ID: "SalesCommissions",
            
                /*report name*/
                RPT_ADJUSTED_COST_BASE: "adjustedcostbase",
                RPT_ASSETS_UNDER_MGT: "assetundermgt",
                RPT_CAPITAL_GAIN: "capitalgain",
                RPT_DSC_FREE_UNIT: "dscfreeunit",
                RPT_TRAILER_FEE: "trailerfee",
                RPT_TRANS_HIST: "transactionhistory",
                RPT_MGT_FEES: "managementfees",
                RPT_SALES_COMMISSIONS: "salescommissions",
                RPT_LINK_TO_IFASTWEB: "linkToIfastWeb",
                /*status*/
                STAT_CANCELLED : "CANCELLED",
                STAT_CMPL : "CMPL",
                STAT_CMPLVIEW : "CMPLVIEW",
                STAT_DELETE: "DELETE",
                STAT_ERR: "ERR",
                STAT_RQST: "RQST",
                /*Parameter*/
                PARAM_DBR_CODE: "DBR_CODE",
                PARAM_FROM_DATE: "STARTDATE",
                PARAM_TO_DATE: "ENDDATE",
                PARAM_AS_AT_DATE: "ASATDATE",
                PARAM_FILENAME: "FILENAME",
                PARAM_PERIOD: "Period",
                
                FILENAMETOOLTIP: "FILENAMETOOLTIP",
                CANCELMSG:"CANCELMSG",
                FIELD_NAME: ""
                
            },
                
            
            OUTPUT_PDFTYPE: "PDF",
            XLS_TYPE: "XLS",
            OUTPUT_EXCELTYPE: "EXL2K",
            DEFAULT_FILE_NAME_DATE_FORMAT: "defaultFileNameDateFormat",
            SPEICAL_CHAR_UNDERSCORE : "_",
            FILE_NAME_LABEL: "fileName",
            webReporting: {
                GENERAL_INFO_ICON: "General Info Icon",
                STMT_SLIPS_PDF: "Statement Slips PDF"
            },
            SEARCH_ICON: "SearchIcon",
            VIOLATION_MESSAGES: {
                KEY: "key",
                ERROR_CODE_REPLACE: "{error_code}",
                SEVERITY_REPLACE: "{severity}",
                FUND_SERVE_CODE_REPLACE: "{fund_serve_code}",
                TO_FUND_SERVE_CODE_REPLACE: "{to_fund_serve_code}"
            },
            TO_FUND_CODE: "toFundCode",
            TO_CLASS_CODE: "toClassCode",
            RRIF_TAX_TYPES: ["2", "B","BR","L", "R"],
            ANNUAL_VALUE: "value",
            RDSP_SERVER_DATE_FORMAT: "DD/MM/YYYY",
            TRUE: "TRUE",
            HYPER_LINK: "Hyper_Link",
            PDF_INVEST_DETAILS: "pdfInvDetails",
            PDF_ADV_TEXT: "advisorText",
            PDF_TELEPHONE_TEXT: "telephone",
            PDF_STATEMENT_ADDR_TEXT: "statements",
            PDF_COUNTRY_TEXT: "canadaCountries",
            ADHOC_RESP_AMOUNTLTD: "amountLTD",
            ADHOC_RESP_AMOUNTYTD: "amountYTD",
            CONT_GRANT_LABEL: "CGLABEL",
            WD_LABEL: "WDLABEL",
            RESP_FR: "DU REEE",
            
            
        };

        var obj = angular.extend({}, constantsObject);

        var constants = function () {
            return constantsObject;
        };

        /**
         * Gets the label from configuration objects.
         * @param {Object} config
         * @param {String} field
         * @returns {*}
         */
        var getLabel = function (config, field) {
            if (config && config[constantsObject.FIELDS] && config[constantsObject.FIELDS][field]) {
                return config[constantsObject.FIELDS][field][constantsObject.LABEL];
            }
            return "";
        };
        
        var getPeriod = function (config, field){
            if (config && config[constantsObject.FIELDS] && config[constantsObject.FIELDS][field]){
                return config[constantsObject.FIELDS][field][constantsObject.BOB.PARAM_PERIOD];
            }

            return "";
        };

        var getFormatCode = function (config,field){
            if (config && config[constantsObject.FIELDS] && config[constantsObject.FIELDS][field]){
                return config[constantsObject.FIELDS][field][constantsObject.FORMAT_CODE];
            }
            return "";
        };

        var getPrintFormatCode = function (config,field){
            if (config && config[constantsObject.FIELDS] && config[constantsObject.FIELDS][field] && config[constantsObject.FIELDS][field].Visible == true){
                return config[constantsObject.FIELDS][field][constantsObject.FORMAT_CODE];
            }
            return "";
        };

        var getPlaceholder = function (config,field){
            if (config && config[constantsObject.FIELDS] && config[constantsObject.FIELDS][field]){
                return config[constantsObject.FIELDS][field][constantsObject.PLACEHOLDER];
            }
            return "";
        };
        var getVisibility = function (config, field, defaultValue){
            if (config && config[constantsObject.FIELDS] && config[constantsObject.FIELDS][field]){
                return config[constantsObject.FIELDS][field][constantsObject.VISIBLE];
            }
            return typeof defaultValue === "boolean" ?  defaultValue : false;
        };
        var getEmptyValue = function (config, field){
            if (config && config[constantsObject.FIELDS] && config[constantsObject.FIELDS][field]){
                return config[constantsObject.FIELDS][field][constantsObject.EMPTY_VALUE];
            }
            return "";
        };
        var getDataType = function (config, field){
            if (config && config[constantsObject.FIELDS] && config[constantsObject.FIELDS][field]){
                return config[constantsObject.FIELDS][field][constantsObject.DATA_TYPE];
            }
            return "";
        };
        var getValue = function (config, field){
            if (config && config[constantsObject.FIELDS] && config[constantsObject.FIELDS][field]){
                return config[constantsObject.FIELDS][field][constantsObject.VALUE];
            }

            return null;
        };

        var createConfigInfoObject = function(config) {
            var configInfo = {
                getLabel: angular.bind(this, getLabel, config),
                getFormatCode: angular.bind(this, getFormatCode, config),
                getPrintFormatCode: angular.bind(this, getPrintFormatCode, config),
                getPlaceholder: angular.bind(this, getPlaceholder, config),
                getVisibility: angular.bind(this, getVisibility, config),
                getEmptyValue: angular.bind(this, getEmptyValue, config),
                getDataType: angular.bind(this, getDataType, config),
                getValue: angular.bind(this, getValue, config),
                getPeriod: angular.bind(this, getPeriod, config),
            };

            return configInfo;
        };

        //support older module.
        obj.constants = constants();

        obj.getLabel = getLabel;
        obj.getFormatCode = getFormatCode;
        obj.getPrintFormatCode = getPrintFormatCode;
        obj.getPlaceholder = getPlaceholder;
        obj.getVisibility = getVisibility;
        obj.getEmptyValue = getEmptyValue;
        obj.getDataType = getDataType;
        obj.getValue = getValue;
        obj.getPeriod = getPeriod;

        obj.createConfigInfoObject = createConfigInfoObject;

        return obj;
    });


// WEBPACK FOOTER //
// ./WebContent/src/_common/services/shared/constants.js